import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { combineLatest, map } from 'rxjs';
import { getFeatureToggle } from '@capital-access/common/feature-toggle';
import { NavConfig, NavConfigFn, NavigationConfigProvider } from '@capital-access/common/navigation';
import { canAccessCapIQProDuringImpersonation } from '@capital-access/common/user';
import { CIQPRO_FEATURE_TOGGLE, CIQPRO_PATH } from './constants';

@Injectable()
export class CiqProNavConfigProvider implements NavigationConfigProvider {
  constructor(private store: Store) {}

  resolveNavConfig: NavConfigFn = () => {
    return combineLatest([
      this.store.select(getFeatureToggle(CIQPRO_FEATURE_TOGGLE)),
      this.store.select(canAccessCapIQProDuringImpersonation)
    ]).pipe(
      map(([isEnabled, canAccessCapIQProDuringImpersonation]) => {
        return <NavConfig>{
          top: [
            {
              localizationKey: 'ciqpro',
              icon: 'f-i-dashboard',
              order: 800,
              link: CIQPRO_PATH,
              enabled: isEnabled && canAccessCapIQProDuringImpersonation
            }
          ]
        };
      })
    );
  };
}
